import CloseIcon from '@ixigo/icons/Close';
import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import { Fragment } from 'react/jsx-runtime';
import { NavigationHeader } from '@/components';
import { WarningExclaimation } from '@/routes/_auth/-icons';
import { RESCHEDULE_ERROR_CONFIG } from '../constants';
import type { RescheduleFailureProps } from '../index.types';

export const RescheduleFailure = (props: RescheduleFailureProps) => {
	const { error, onClose } = props;
	const actions =
		RESCHEDULE_ERROR_CONFIG[error.type] ?? RESCHEDULE_ERROR_CONFIG.TECH_ERROR;

	return (
		<Fragment>
			<NavigationHeader
				title=""
				leftAction={onClose}
				leftIcon={<CloseIcon />}
			/>
			<div className="bg-primary px-20 pb-30 flex flex-col gap-y-10">
				<div className="flex items-center justify-center">
					<WarningExclaimation className="size-50px" />
				</div>
				<div className="flex flex-col gap-y-10 text-center">
					<Typography variant="h5" fontWeight="medium">
						{error.title}
					</Typography>
					<Typography variant="body-md">{error.message}</Typography>
				</div>
			</div>
			<div className="bg-primary px-20 py-2.5 flex justify-between items-center gap-x-20">
				{actions.map((action) => (
					<Button
						key={action.label}
						onClick={props[action.handler]}
						className="w-full"
						size="lg"
						variant={action.variant}
					>
						{action.label}
					</Button>
				))}
			</div>
		</Fragment>
	);
};
